import { ENV_MODE_OPTIONS, type EnvModeSelection } from '@/utils/envMode'
import { Segmented } from 'antd'
import './EnvModeSwitch.css'

interface EnvModeSwitchProps {
  value: EnvModeSelection
  onChange: (mode: EnvModeSelection) => void
}

/**
 * Prod / Test / All. Every page that scopes its data to an environment shows
 * this same switch, so it looks and behaves the same on all of them --
 * `toModeParam` turns the selection into what the endpoints take.
 */
export function EnvModeSwitch({ value, onChange }: EnvModeSwitchProps) {
  return (
    <Segmented
      className='env-mode-switch'
      value={value}
      onChange={onChange}
      options={ENV_MODE_OPTIONS}
    />
  )
}
